import styled from 'styled-components'

export const InlineList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 16px;
`
export const ContentFooter = styled.div`
  padding: 16px 24px;
  background-color: ${(props) => props.theme.colors.neutral.grayscale.A100};
`
